import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

export default async ({ Vue, redirect, store, router }) => {
  if (process.env.ENV === "dev" || process.env.ENV === "testing") {
    return;
  }

  const options = {
    Vue,
    dsn: process.env.SENTRY_DNS,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        // Cada host de esta lista recibe las cabeceras sentry-trace/baggage.
        // El CORS de API Gateway se configura POR RUTA, no por host: si una sola
        // ruta del host no las permite, sus peticiones fallan con Network Error.
        // Antes de anadir un host hay que comprobar TODAS sus rutas, no una:
        //   curl -i -X OPTIONS "<host><ruta>" -H "Origin: https://ncl.live" \
        //     -H "Access-Control-Request-Method: GET" \
        //     -H "Access-Control-Request-Headers: sentry-trace,baggage"
        // La respuesta debe incluir baggage y sentry-trace en Access-Control-Allow-Headers.
        tracingOrigins: [
          /^\//,
          process.env.SENTRY_APP_HOST,
          process.env.API_BASE_URL,
          process.env.CORE_DATA_SERVICES_API_URL,
          process.env.AGENT_DATA_SERVICES_API_URL,
          process.env.MEDIA_MANAGER_API_URL,
          process.env.USER_ADMIN_API_URL,
        ].filter(Boolean),
      }),
    ],
    environment: process.env.ENV,
    tracesSampleRate: 1.0,
  };

  Sentry.init(options);
};
